/**
 * Voice pipeline probe — exposed as `window.__voiceStats` (all builds; it's a
 * few counters). Answers the "browser vs frontend vs backend" triage in one
 * console read during a live session:
 *
 *   __voiceStats
 *   → { audioFramesIn: 0,  ... }               backend/provider sent nothing
 *   → { audioFramesIn: 240, ctxState: 'suspended' }  audio arrived, but the
 *       AudioContext is blocked by autoplay policy (classic Safari) — the
 *       graph wasn't unlocked inside a user gesture
 *   → { audioFramesIn: 240, ctxState: 'running' }    frames arrived AND the
 *       graph runs — if still silent, check masterGain volume / OS output
 */

import { peekAudioContextState, getAudioSettings } from '../utils/audio-theme';

export const voiceStats = {
  /** `voice_audio` frames received from the server this session. */
  audioFramesIn: 0,
  /** Chunks handed to the PCM player (0 with frames in ⇒ player init failed). */
  chunksEnqueued: 0,
  /** True once createPcmPlayer returned non-null for the session. */
  playerReady: false,
  get ctxState(): string {
    return peekAudioContextState();
  },
  get masterVolume(): number {
    return getAudioSettings().volume;
  },
  reset(): void {
    this.audioFramesIn = 0;
    this.chunksEnqueued = 0;
    this.playerReady = false;
  },
};

if (typeof window !== 'undefined') {
  (window as unknown as { __voiceStats?: typeof voiceStats }).__voiceStats = voiceStats;
}
